// Deliberately a sibling to components/workflowInstances/workflowStatusMixin.js, not a merge into
// it -- ReviewStatusId is a separate field from a task's StatusId (see the Phase 3 design decision:
// an email task pending review still shows as InProgress everywhere via the existing status mixin).
const reviewStatusAttrs = {
  1: { color: 'orange darken-1', dark: true }, // Pending Internal Review
  2: { color: 'green', dark: true }, // Approved & Sent
  3: { color: 'red', dark: true } // Rejected
}

export default {
  methods: {
    reviewStatusAttrs (reviewStatusId) {
      return reviewStatusAttrs[reviewStatusId] || { color: 'grey lighten-2', dark: false }
    }
  }
}
